import { useMount } from "ahooks";
import React from "react";
import qs from "qs";
import * as Sentry from "@sentry/react";
import Cookies from "js-cookie";
import { onINP } from "web-vitals";
import { useAtom } from "jotai";
import Tracking from "@t8891/tracking";
import { htmlTreeAsString } from "@t8891/helper";
import { initComsorcetag } from "@t8891/third-parties";
import { postCollectData } from "@Services/common";

import { initTracking } from "@Lib/jotai/tracking";
import initializeFireBase from "../../utils/initializeFireBase";
import { g4 } from "../../utils/helper";

const InitComponent = () => {
  const [, updateInitTracking] = useAtom(initTracking);

  const IS_PRODUCTION = process.env.SERVER_ENV === "production";

  const initSentry = () => {
    const host = location.hostname;
    if (host.indexOf(".dev") !== -1 || host.indexOf(".test") !== -1) return;
    Sentry.init({
      dsn: "https://97ca615b88534bd69d6304c686f3b723@sentry.addcn.com/10",
      // 错误事件采样率
      sampleRate: 0.2,
      // 性能统计采样率
      tracesSampleRate: 0.1,
      // 版本/健康跟踪
      release: "newcar@v1.0.0",
      integrations: [
        Sentry.browserTracingIntegration({
          beforeStartSpan: function (context) {
            if (window.page_route) {
              return {
                ...context,
                name: "newCar:{{ $routeName }}",
              };
            }

            var path = location.pathname;

            if (path.includes("/Summary.html")) {
              return {
                ...context,
                name: "/*/Summary.html",
              };
            } else if (path.includes("/HDPhoto.html")) {
              return {
                ...context,
                name: "/*/HDPhoto.html",
              };
            }

            return {
              ...context,
              name: location.pathname
                .replace(/id=\d+/, "id=id")
                .replace(/\/\d+/g, "/:id")
                .replace(/\/tag\/.*/, "/tag/:id")
                .replace(/\/(\d+,+|\d+)+/g, "/:id"),
            };
          },
          tracePropagationTargets: [
            /^https:\/\/www\.8891\.com\.tw\/api/,
            /^https:\/\/c\.8891\.com\.tw\/api/,
            /^https:\/\/www\.test\.8891\.com\.tw\/api/,
          ],
          enableInp: true,
          enableLongAnimationFrame: true,
        }),
      ],
    });
  };

  const initFaceBook = () => {
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src =
        "//connect.facebook.net/zh_TW/sdk.js#xfbml=1&#xfbml=1&amp;version=v2.9&#xfbml=1&version=v2.9&appId=385733414829754";
      (fjs as any).parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  };

  const initGlobalSource = () => {
    if (!!window.dimensions) {
      g4("remarketing", window.dimensions);
    }

    let { globalSource } = qs.parse(location.search, { ignoreQueryPrefix: true });
    if (!!globalSource) {
      Cookies.set("globalSource", globalSource, { expires: 10 });
      Cookies.set("globalSessionSource", globalSource);
      if (globalSource === "fb-cpc" || globalSource === "facebook-cpc") {
        Cookies.set("fbSource", globalSource, { expires: 30 });
      }
    }
  };
  const initInp = () => {
    try {
      onINP(
        function (info) {
          if (info?.value > 200) {
            postCollectData({
              es_tag: "newcar_touch_next_inp_analytics",
              // device_id: device_id,
              url: window.location.href,
              uri: window.location.origin + window.location.pathname,
              ua: navigator.userAgent,
              inpInfo: {
                ...info,
                entries: info.entries.map((entry) => ({
                  ...entry,
                  name: entry.name,
                  entryType: entry.entryType,
                  duration: entry.duration,
                  xpath: htmlTreeAsString(entry.target),
                })),
              },
              pageRoute: window?.page_route || "",
            });
          }
        },
        { reportAllChanges: true },
      );
    } catch (e) {
      console.error(e);
    }
  };

  const initTrack = () => {
    const userMessage = localStorage.getItem("userMessage");
    /** 处理埋点 */
    const tracking = new Tracking({
      debug: !IS_PRODUCTION,
      gaParams: {
        user_id: !!userMessage ? JSON.parse(userMessage).mId : "",
        device_id: localStorage.getItem("uuid"),
        sub_platform: "PC",
      },
      trackApi: !IS_PRODUCTION
        ? "https://assets.8891.com.tw/track-debug/pc/c.8891.com.tw/new-car-config-track.json"
        : "https://assets.8891.com.tw/track/pc/c.8891.com.tw/new-car-config-track.json",
    });
    updateInitTracking(tracking);
  };

  useMount(() => {
    initTrack();
    initInp();
    initSentry();
    initFaceBook();
    initGlobalSource();
    // fb消息推送
    initializeFireBase();
    initComsorcetag("34024275");
  });
  return <></>;
};

export default InitComponent;
